//ユーザ登録完了
import {useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { HttpPostData, JumpPage } from '../../common/Util';
import { PaymentPageType, NewProductParam, ResponseParamBase } from '../../common/Types';
import { LoginStateConext } from "../../context/AuthContext";
import { TitleParamContext } from '../../context/TitleContext';
import { RegisterPageInfo, RegisterPageTypeEnum } from '../../context/RegisterPageTypeContext';
import market from "../../css/market.module.scss";
import base from "../../css/base.module.css";


type ResponseParam = ResponseParamBase & {
    hasTrial: boolean,
}

/**
 * ユーザ登録の完了。登録時のパラメータで、表示の切り替えあり。
 * */
export const CompleteRegister = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const loginState = useContext(LoginStateConext);
    //const pageParam = queryString.parse(location.search) as RegistEmailParam;
    const titleConext = useContext(TitleParamContext);
    const registerPageType = location.state as RegisterPageInfo

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [hasTrialLicense, setHasTrialLicense] = useState<boolean>(false);


    const getText = () => {
        let returnText: string;
        if (registerPageType != null) {
            switch (registerPageType.registerPageType) {
                case RegisterPageTypeEnum.License:
                    returnText = "[ClickerAce新規ライセンス購入]ボタンよりライセンス購入頂けます。";
                    break;
                case RegisterPageTypeEnum.Pccase:
                    returnText = "[ClickerAceRPA端末用ケース 購入]ボタンより購入頂けます。";
                    break;
                default:
                    returnText = "[ClickerAce新規ライセンス購入]ボタンよりライセンス購入頂けます。";
                    break;
            }
        } else {
            returnText = "[ClickerAce新規ライセンス購入]ボタンよりライセンス購入頂けます。";
        }
        return (
            <div className={base.messageFont} style={{ textAlign: "center" }}>
                サポート会員の登録が完了しました。<br/>
                {returnText}<br />
            </div>
        );
    }

    const getButton = () => {
        if (registerPageType != null) {
            switch (registerPageType.registerPageType) {
                case RegisterPageTypeEnum.License:
                    return <button className={market.twoRowButton} onClick={(e) => { JumpPage("/MyPage/NewLicense", { categoryCode: "01", productCode: "01", paymentPageType: PaymentPageType.New, lisenceKey: "" } as NewProductParam, "", navigate) }}><span>ClickerAce</span><br />新規ライセンス購入</button>;
                case RegisterPageTypeEnum.Pccase:
                    return <button className={market.twoRowButton} onClick={(e) => { JumpPage("/MyPage/NewLicense", { categoryCode: "02", productCode: "04", paymentPageType: PaymentPageType.Pccase, lisenceKey: "" } as NewProductParam, "", navigate) }}>RPA端末用ケース (※1)　購入<br />（ Clicker Ace 3ヶ月 新規ライセンス付属 ）</button>;
                default:
                    return <button className={market.twoRowButton} onClick={(e) => { JumpPage("/MyPage/NewLicense", { categoryCode: "01", productCode: "01", paymentPageType: PaymentPageType.New, lisenceKey: "" } as NewProductParam, "", navigate) }}><span>ClickerAce</span><br />新規ライセンス購入</button>;
            }
        } else {
            return <button className={market.twoRowButton} onClick={(e) => { JumpPage("/MyPage/NewLicense", { categoryCode: "01", productCode: "01", paymentPageType: PaymentPageType.New, lisenceKey: "" } as NewProductParam, "", navigate) }}><span>ClickerAce</span><br />新規ライセンス購入</button>;
        }
    }

    useEffect(() => {
        (async () => {
            titleConext.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "サポート会員情報", secondSubTitle: "（本登録）" });
            HttpPostData<ResponseParam>("/License/GetUserTrialLicense", { Email: loginState.loginInfo.email }, setIsLoading)
                .then((response) => {
                    if (response.data.resultFlg) {
                        setHasTrialLicense(response.data.hasTrial);
                    }
                })
        })()
    }, []);

    return (
        <>
            <section className={market.marketArea}>
                <div className={market.marketAreaInner}>
                    {getText()}                                   
                    <div className={market.marketFooterArea}>
                        <button className={market.marketBackButton} style={{ visibility: "hidden" }}>戻る</button>
                        <button className={market.marketButton} onClick={(e) => { JumpPage("/MyPage", {}, "", navigate); }}>マイページ</button>
                        {getButton()}
                        <button className={market.marketBackButton} style={{ visibility: "hidden" }}>進む</button>
                    </div>
                    <div className={base.messageFont} style={{ textAlign: "center" }}>
                        [ClickerAceお試しライセンス発行]ボタンより<br />
                        有償サポートの拡張機能を試す場合に必要となる<br />
                        ３か月間利用可能なライセンスコードを発行頂けます。<br />
                        ご利用は、お試し目的に限ります。<br/>
                    </div>
                    <div className={market.mypageButtonMenu}>
                        <button className={market.myPageButton} disabled={isLoading || hasTrialLicense} onClick={(e) => { JumpPage("/mypage/trial", {}, "", navigate); }}>
                            <span>
                                <span>ClickerAce</span><br />
                                <span>お試しライセンス発行</span>
                            </span>
                        </button>
                    </div>
                </div>
            </section>            
        </>
    );
}